export default function Testimonials() {
  return (
    <section class="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="absolute inset-0">
        <img src="/img/tadano_AC2040-1_road.png" alt="" class="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-300/60 via-slate-900/60 to-slate-950"></div>
      </div>
      {/* <div class="absolute inset-0 -z-10 bg-[radial-gradient(45rem_50rem_at_top,var(--color-indigo-100),white)] opacity-20"></div>
      <div class="absolute inset-y-0 right-1/2 -z-10 mr-16 w-[200%] origin-bottom-left skew-x-[-30deg] bg-white shadow-xl ring-1 shadow-indigo-600/10 ring-indigo-50 sm:mr-28 lg:mr-0 xl:mr-16 xl:origin-center"></div> */}
      <div className="relative z-10 h-full flex items-center">
        <div class="bg-slate-900/35 backdrop-blur-md dark:backdrop-blur-sm border border-white/10 mx-auto max-w-2xl lg:max-w-4xl p-10 rounded-3xl">
          <h2 class="text-center text-3xl font-bold text-white">What our clients say</h2>
          <p class="text-center text-2xl text-white align-bottom text-gray-300">"Exceeding expectations, consistently"</p>
          <figure class="mt-2 p-5">
            <blockquote class="text-center text-lg/4 font-semibold text-white sm:text-2xl/9 ">
              <p>“Finally a digital solution that works, easy to use and with no fuss.”</p>
              <p class="text-sm font-bold uppercase pt-3">Sam Christopher - RW Christopher</p>
            </blockquote>
          </figure>
          <figure class="mt-2 p-5">
            <blockquote class="text-center text-lg/4 font-semibold text-white sm:text-2xl/9">
              <p>“Fleet asset maintenance and hire book all in one very simple but effective system.”</p>
              <p class="text-sm font-bold uppercase pt-3">Ryan Ward - AW Plant Services</p>
            </blockquote>
          </figure>
          <figure class="mt-2 p-5">
            <blockquote class="text-center text-lg/4 font-semibold text-white sm:text-2xl/9">
              <p>“A truly simple and efficient way to operate our hire fleet and fleet maintenance calendar.”</p>
              <p class="text-sm font-bold uppercase pt-3">Oscar Kirby - RJ Crane Hire</p>
            </blockquote>
          </figure>
          <figure class="mt-2 p-5">
            <blockquote class="text-center text-lg/4 font-semibold text-white sm:text-2xl/9">
              <p>“A massive upgrade for our hire desk, making hire bookings flexible, efficient and fully mobile.”</p>
              <p class="text-sm font-bold uppercase pt-3">Chris Ashworth - Eastern Crane Hire</p>
            </blockquote>
          </figure>
        </div>
      </div>
    </section>
  )
}
